import Forms from './Forms';
import jQuery from 'jquery';
export default class DynamicNewsletter {
    constructor(section) {
        this.$el = jQuery(section.el);
        this.forms = new Forms(this.$el);
    }
    onSectionUnload() {
        this.forms.unload();
    }
}
